<template>
	<div>
		<v-container
			grid-list-xl
		>
			<v-layout
				row
				justify-center
			>
				<v-flex
					xs12
					md8
					pa-0
				>
					<slot name="alert"/>
				</v-flex>
			</v-layout>
		</v-container>
		<v-layout
			row
			wrap
			align-center
			justify-center
			ma-3
		>
			<v-flex
				pa-0
				xl8
			>
				<v-layout
					row
					wrap
					justify-center
				>
					<v-card
						width="100%"
						class="overflow-scroll"
					>
						<v-toolbar
							flat
							color="white"
						>
							<v-text-field
								v-model="search"
								append-icon="search"
								label="Search"
								single-line
								hide-details
							/>
						</v-toolbar>
						<v-data-table
							:headers="headers"
							:items="publications.models"
							:loading="publications.loading"
							hide-actions
							no-data-text=""
						>
							<!-- <template
								slot="headers"
								slot-scope="props"
							>
								<tr>
									<th
										v-for="header in props.headers"
										:key="header.text"

									>
										<div class="table-item-width">
											<span v-html="header.text"/>
										</div>
									</th>
								</tr>
							</template> -->
							<template
								slot="items"
								slot-scope="props"
							>
								<td class="publication-id">{{ props.item.id }}</td>
								<td class="publication-name">
									<img :src="props.item.logo" class="pr-2 publication-logo"/>
									{{ props.item.name }}
								</td>
								<td>{{ props.item.urlId }}</td>
								<td class="text-xs-right">{{ props.item.country }}</td>
								<td class="text-xs-right">
									{{ props.item.mozStats.domainAuthority | formatNumber }}
								</td>
								<td class="text-xs-right">{{ props.item.popularityAlexis | shortNumber }}</td>
								<td class="text-xs-right">{{ props.item.popularityManual | formatNumber }}</td>
								<td class="pa-0 text-xs-center">
									<v-btn
										icon
										flat
										color="success"
										@click="showEdit(props.item)"
									>
										<v-icon>edit</v-icon>
									</v-btn>
								</td>
								<td class="pa-0 text-xs-center">
									<v-menu>
										<v-btn
											slot="activator"
											small
											icon
										>
											<v-icon>more_vert</v-icon>
										</v-btn>
										<v-list>
											<v-list-tile @click="refetchMoz(props.item)">
												<v-list-tile-title>Refetch Moz</v-list-tile-title>
											</v-list-tile>
											<v-list-tile @click="refetchAlexa(props.item)">
												<v-list-tile-title>Refetch Alexa</v-list-tile-title>
											</v-list-tile>
<!--											<v-list-tile @click="refetchSimilar(props.item)">-->
<!--												<v-list-tile-title>Refetch SimilarWeb</v-list-tile-title>-->
<!--											</v-list-tile>-->
											<v-list-tile @click="setImageUpload(props.item)">
												<v-list-tile-title>Update Image</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</td>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-dialog
			v-model="editDialog"
			max-width="800"
		>
			<v-card v-if="editDialog">
				<v-container grid-list-xl>
					<PublicationForm
						:edit-publication="editPublication"
						@update="updatePublication"
						@close="editDialog = false"
					/>
				</v-container>
			</v-card>
		</v-dialog>
		<v-dialog
			ref="dialog"
			v-model="imageUpload.show"
			max-width="800px"
		>
			<v-card v-if="imageUpload.show" class="px-3">
				<ImageUpload
					:item="imageUpload.publication"
					closable
					@close="imageUpload.show = false"
				/>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { Publications } from '@/models/Publication';
import Debounce from 'lodash/debounce';

export default {
	components: {
		PublicationForm: () => import('@/components/Publication/PublicationForm'),
		ImageUpload: () => import('@/components/ImageUpload'),
	},
	data() {
		return {
			publications: new Publications(),
			headers: [
				{ text: 'ID', value: 'id', sortable: false },
				{ text: 'Name', value: 'name', sortable: false },
				{ text: 'URL ID', value: 'urlId', sortable: false },
				{ text: 'Country', value: 'country', sortable: false },
				{ text: 'Domain Authority', value: 'mozStats.domainAuthority', sortable: false },
				{ text: 'Reach (users)', value: 'popularityAlexis', sortable: false },
				{ text: 'Manual Popularity', value: 'popularityManual', sortable: false },
				{ text: 'Edit', value: 'edit', sortable: false, align: 'center' },
				{ text: 'More', value: 'more', sortable: false, align: 'center' },
			],
			editPublication: null,
			editPublicationClone: null,
			editDialog: false,
			search: '',
			imageUpload: { show: false, publication: null },
		};
	},
	watch: {
		search() {
			this.debouncedSearch();
		},
	},
	created() {
		this.debouncedSearch = Debounce(this.pubSearch, 500);
		// Guard because empty query does not work
		this.publications.set('search', 'A');
		this.publications.fetch().then().catch(() => {
			this.$notify('error', 'Failed to get publications, refresh to try again');
		});
	},
	methods: {
		pubSearch() {
			// Guard because empty query does not work
			if (this.search === '') {
				this.publications.set('search', 'A');
			}
			else {
				this.publications.set('search', this.search);
			}
			this.publications.fetch().then().catch(() => {
				this.$notify('error', 'Search failed, refresh and try again.');
			});
		},
		showEdit(item) {
			this.editPublication = item;
			this.editPublicationClone = {
				name: item.name,
				urlId: item.urlId,
				country: item.country,
				popularityManual: item.popularityManual,
			};
			this.editDialog = true;
		},
		setImageUpload(publication) {
			this.imageUpload.publication = publication;
			this.imageUpload.show = true;
		},
		updatePublication(publication) {
			this.editPublication.name = publication.name;
			this.editPublication.urlId = publication.urlId;
			this.editPublication.country = publication.country;
			this.editPublication.popularityManual = Math.round(publication.popularityManual);

			this.editPublication.save().then(() => {
				this.$notify('success', `Publication ${this.editPublication.name} has been updated.`);
				this.editDialog = false;
			}).catch(() => {
				this.$notify('error', `Failed to update publication ${this.editPublication.name}.`);
			});
		},
		refetchMoz(publication) {
			publication.refetchMoz().then(() => {
				this.$notify('success', 'Successfully refetched Moz.');
			}).catch(({ response }) => {
				this.$notify('error', response.response.data.message);
			});
		},
		refetchAlexa(publication) {
			publication.refetchAlexa().then(() => {
				this.$notify('success', 'Successfully refetched Alexa.');
			}).catch(({ response }) => {
				this.$notify('error', response.response.data.message);
			});
		},
		refetchSimilar(publication) {
			publication.refetchSimilar().then(() => {
				this.$notify('success', 'Successfully refetched SimilarWeb.');
			}).catch(({ response }) => {
				this.$notify('error', response.response.data.message);
			});
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep td {
	word-break: break-all;
}
.overflow-scroll {
	overflow: auto;
}
.table-item-width {
	max-width: 150px;
	text-align: left;
}
.text-max {
	display: flex;
	width: 20px;
	word-wrap: break-word;
}
.publication-name {
	display: flex;
	align-items: center;
}
.publication-logo {
	max-height: 48px;
}
.publication-id {
	white-space: nowrap;
	text-align: right;
}
</style>
